import createBehavior from '../create-behavior';
import $ from 'jquery';
export default () => {
  const NAME = '.product-photo';
  class ProductPhoto {

    constructor($el, context, settings) {

      this.actionsTrigger($el);
    }

    actionsTrigger($el) {
      $el.find(NAME + '__trigger').on('click', () => {
        $el.find(NAME + '__actions').toggleClass(NAME.substr(1) + '__actions--expanded');
      });
    }
  }

  createBehavior(NAME, 'ProductPhoto', ProductPhoto);
}



// WEBPACK FOOTER //
// ./js/src/behaviors/product-photo.js